<template>
  <div class="content">
    <div class="header">
      <div
        :class="is_status == index ? 'btn btnCurrent' : 'btn'"
        v-for="(item, index) in titleDatas"
        :key="index"
        @click="go(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="bottom">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 0,
      titleDatas: [
        {
          title: "全部人群",
          path: "sign"
        },
        {
          title: "人群分类",
          path: "classify"
        },
        {
          title: "营销记录",
          path: "record"
        }
      ]
    };
  },
  methods: {
    go(type) {
      this.is_status = type;
      this.$router.push(this.titleDatas[type].path);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    overflow-y: auto;
  }
}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>
